import {
  ArrowsRepeat,
  Copy,
} from '@unified-checkout/design-system/icons/index';
import type { TFunction } from 'i18next';
import { QUERY_KEYS } from '../query-keys';

export const API_KEYS_TYPES = {
  API_KEYS: 'apiKey',
  PUBLIC_KEY: 'publicKey',
  SECRET_KEY: 'secretKey',
  HMAC: 'hmac',
} as const;

const API_KEYS_CARDS_ACTIONS = (t: TFunction) => ({
  copy: {
    key: 'copy',
    label: t('innerLayout.apiKeys.actions.copy'),
  },
  view: {
    key: 'view',
    label: t('innerLayout.apiKeys.actions.view'),
  },
  recreate: {
    key: 'recreate',
    label: t('innerLayout.apiKeys.actions.recreate'),
  },
});

export const API_KEYS_CARDS = (t: TFunction) => {
  const actions = API_KEYS_CARDS_ACTIONS(t);

  return [
    {
      type: API_KEYS_TYPES.API_KEYS,
      title: t('innerLayout.apiKeys.titles.apiKey'),
      description: t('innerLayout.apiKeys.descriptions.apiKey'),
      actions: [actions.copy, actions.view, actions.recreate],
    },
    {
      type: API_KEYS_TYPES.PUBLIC_KEY,
      title: t('innerLayout.apiKeys.titles.publicKey'),
      description: t('innerLayout.apiKeys.descriptions.publicKey'),
      hasTestLiveTag: true,
      actions: [actions.copy, actions.view, actions.recreate],
    },
    {
      type: API_KEYS_TYPES.SECRET_KEY,
      title: t('innerLayout.apiKeys.titles.secretKey'),
      description: t('innerLayout.apiKeys.descriptions.secretKey'),
      hasTestLiveTag: true,
      actions: [actions.copy, actions.view, actions.recreate],
    },
    {
      type: API_KEYS_TYPES.HMAC,
      title: t('innerLayout.apiKeys.titles.hmac'),
      description: t('innerLayout.apiKeys.descriptions.hmac'),
      actions: [actions.copy, actions.view],
    },
  ];
};

export const ACTIONS = {
  COPY: 'copy',
  VIEW: 'view',
  RECREATE: 'recreate',
};

export const MODAL_ACTIONS_CONFIG = {
  [ACTIONS.VIEW]: {
    getSupportingText: (type: string, apiKeysData: any, t: any) =>
      apiKeysData[type],
    getPrimaryBtnText: (t: any) => t('innerLayout.apiKeys.actions.copy'),
    getIcon: () => Copy,
  },

  [ACTIONS.RECREATE]: {
    getSupportingText: (type: string, _apiKeysData: any, t: any) =>
      t('innerLayout.apiKeys.modal.recreateDescription', {
        keyType: t(`innerLayout.apiKeys.titles.${type}`),
      }),
    getPrimaryBtnText: (t: any) => t('innerLayout.apiKeys.actions.recreate'),
    getIcon: () => ArrowsRepeat,
  },
};

export const API_QUERY_KEYS_MAPPER = {
  [API_KEYS_TYPES.API_KEYS]: [QUERY_KEYS.GET_API_KEY],
  [API_KEYS_TYPES.SECRET_KEY]: [QUERY_KEYS.GET_PUBLIC_SECRET_KEY],
  [API_KEYS_TYPES.PUBLIC_KEY]: [QUERY_KEYS.GET_PUBLIC_SECRET_KEY],
};

export const REVOKED_KEY_ERROR_STATUS = 410;

export const KEYS_OPERATIONS = {
  CREATE: 'create',
  REVOKE: 'revoke',
  RENEW: 'renew',
} as const;
